import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'META_COMBUSTIVEL_TERMO_USO_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function initForm(registro = {}) {
    return [
        initialize('metaCombustivelTermoUsoForm', registro)
    ];
}

export function setFiltro(filtro = {}) {
    return {
        type: 'META_COMBUSTIVEL_TERMO_USO_FILTRO',
        payload: {
			filtro: filtro
		}
    };
}


export function setAguardando(aguardando) {
    return {
        type: 'META_COMBUSTIVEL_TERMO_USO_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function getLista(documentos) {
	return (dispatch, getState) => {
		dispatch(setAguardando(true));

    	axios.get(`${consts.API_URL}/termoUso?id_tipo=1
		`).then(resp => {
			dispatch({
		        type: 'META_COMBUSTIVEL_TERMO_USO_LISTADO',
		        payload: resp
		    });
			dispatch(setAguardando(false));
		}).catch(e => {
			setErroAPI(e);
			dispatch(setAguardando(false));
		});
	}
}

export function salvar(registro) {
    return async (dispatch, getState) => {
		if (!registro.id) {				
			await axios.post(`${consts.API_URL}/termoUso`, {
				...registro,
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));		
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/termoUso`, {
				...registro,
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro, evento) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/termoUso?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
			if (evento) {
				evento();
			}
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getDownload(id) {
	return (dispatch, getState) => {
		
		axios.get(`${consts.API_URL}/termoUso/download?id=${id || 0}`)
		.then(resp => {
			if (resp.data && resp.data.base64) {

				if (window.confirm('O arquivo foi carregado com sucesso. Deseja baixá-lo agora?')) {
					// Converte Base64 para byte array
					const byteCharacters = atob(resp.data.base64);
					const byteNumbers = new Array(byteCharacters.length);
					for (let i = 0; i < byteCharacters.length; i++) {
					byteNumbers[i] = byteCharacters.charCodeAt(i);
					}
					const byteArray = new Uint8Array(byteNumbers);
		
					// Cria Blob
					const blob = new Blob([byteArray]);
		
					// Cria link temporário
					const link = document.createElement("a");
					link.href = window.URL.createObjectURL(blob);
					link.download = `${resp.data.nome}.${resp.data.extensao || ''}`;
					link.click();
		
					// Libera memória
					window.URL.revokeObjectURL(link.href);
				}
			}
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function verificarTermoUso() {
	return async (dispatch, getState) => {
    	await axios.get(`${consts.API_URL}/termoUso?id_tipo=1&&vigente=true
		`).then(async resp => {
			const termoUso = resp.data[0];

			if (termoUso) {
				await axios.get(`${consts.API_URL}/usuarioTermoUso?id_termo_uso=${termoUso.id}&id_usuario=${getState().auth.usuario ? getState().auth.usuario.id : 0}`)
				.then(resp => {
					const usuarioTermoUso = resp.data[0];

					if (usuarioTermoUso) {
						dispatch({
							type: 'META_COMBUSTIVEL_TERMO_USO_STATUS',
							payload: {
								aceito: true
							}
						});
					} else {
						dispatch({
							type: 'META_COMBUSTIVEL_TERMO_USO_STATUS',
							payload: {
								aceito: false,
								termoUso: termoUso
							}
						});
					}
				}).catch(e => {
					setErroAPI(e);
				});
			} else {
				dispatch({
					type: 'META_COMBUSTIVEL_TERMO_USO_STATUS',
					payload: {
						aceito: true
					}
				});
			}
		}).catch(e => {
			setErroAPI(e);
			
		});
	}
}

export function confirmarTermoUso(id) {
    return async (dispatch, getState) => {
		await axios.post(`${consts.API_URL}/usuarioTermoUso`, {
			id_termo_uso: id,
			id_usuario: getState().auth.usuario.id
		}).then(resp => {
			setSuccess('Termos de uso aceitos com sucesso.');
			dispatch(verificarTermoUso());
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaAceites(id) {
	return (dispatch, getState) => {
		dispatch(setAguardando(true));

		dispatch({
			type: 'META_COMBUSTIVEL_TERMO_USO_ACEITE_LISTADO',
			payload: {
				data: []
			}
		});

    	axios.get(`${consts.API_URL}/usuarioTermoUso/logs?id_termo_uso=${id}`).then(resp => {
			dispatch({
		        type: 'META_COMBUSTIVEL_TERMO_USO_ACEITE_LISTADO',
		        payload: resp
		    });
			dispatch(setAguardando(false));
		}).catch(e => {
			setErroAPI(e);
			dispatch(setAguardando(false));
		});
	}
}